import { render, staticRenderFns } from "./NotificationWarning.vue?vue&type=template&id=10cca58a&scoped=true&"
import script from "./NotificationWarning.vue?vue&type=script&lang=js&"
export * from "./NotificationWarning.vue?vue&type=script&lang=js&"
import style0 from "./NotificationWarning.vue?vue&type=style&index=0&id=10cca58a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cca58a",
  null
  
)

export default component.exports